import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import moment from 'moment'
import ReactGA from "react-ga"

import {
  ACCOUNT,
  BOOKINGCALENDAR, // from phase 1
  BOOKING,
  MODAL,
  HOLIDAY,
} from '../../../reduxs'

import { SmallCalendar, ModalBookingList, ModalInformation } from '../../../components'
import { CREATE_BOOKING, BOOKING_DETAIL_VIEW } from '../../../helpers'
import { getPositionBookingCard, getCalendarString } from '../../../helpers/functions'

import { StyleYear } from './style'

export class Year extends Component {
  constructor(props) {
    super(props)
    const { accountReducer } = this.props;
    let selectedDate = new Date(props.year, props.month - 1, props.date, 0, -new Date().getTimezoneOffset())
    this.state = {
      languages: 'EN',
      position: { x: 0, y: 0 },
      date: new Date(),
      trashed: false,
      ownerName: accountReducer.user.username,
      limit: 100,
      page: 1,
      username: accountReducer.user.username,
      startDatetime: '',
      endDatetime: '',
      data: [],
      nameModal: '',
      itemId: '',
      bookingId: '',
      deletedReason: '',
      selectedDate,
      isYearAndDay: true,
      headerName: null,
      descriptionName: null,
      buttonName: null
    }
    //GA TrackingId
    ReactGA.initialize("UA-153387162-1");
    ReactGA.pageview("(Year) Calendar Page")
  }

  componentDidMount() {
    const { year, bookingcalendarAction, accountReducer } = this.props
    const { userId, username } = accountReducer.user

    bookingcalendarAction.getAllListEvent({
      userId,
      username,
      year,
      status: '[0,1,2]'
    })
  }

  componentWillMount () {
    this.getholiday(false)
  }

  componentDidUpdate(prevProps) {
    const { year, bookingcalendarAction, accountReducer } = this.props
    const { companyId, userId, username } = accountReducer.user

    this.getholiday(true)

    if (prevProps.year !== year) {
      bookingcalendarAction.clearAllListEvent()
      bookingcalendarAction.getAllListEvent({
        userId,
        companyId,
        username,
        year,
        status: '[0,1,2]'
      })
    }
  }

  getholiday = (param) => {
    const props = { ...this.props }
    const { holidayAction, accountReducer } = props
    let selectedDate = new Date(props.year, props.month - 1, props.date, 0, -new Date().getTimezoneOffset())
    const startDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), -7)
    const endDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 38)
    const startDateString = [startDate.getFullYear(), 1, 1].join('-')
    const endDateString = [endDate.getFullYear(), 12, 31].join('-')
    if (param) {
      if (selectedDate.valueOf() !== this.state.selectedDate.valueOf()) {
        this.setState({
          selectedDate: selectedDate
        }, () => {
          holidayAction.getListHoliday({
            startDatetime: startDateString,
            endDatetime: endDateString,
            companyId: accountReducer.user.companyId,
            limit: 999
          })
        })
      }
    } else {
      if (this.state.selectedDate.valueOf()) {
        this.setState({
          selectedDate: selectedDate
        }, () => {
          holidayAction.getListHoliday({
            startDatetime: startDateString,
            endDatetime: endDateString,
            companyId: accountReducer.user.companyId,
            limit: 999
          })
        })
      }
    }

  }

  objGetParams = () => {
    const month = this.props.match.params.month
    const year = this.props.match.params.year
    const {
      trashed,
      limit,
      ownerName,
    } = this.state
    const lastDayOfThisMonth = this.getTotalDayInMonth(month - 1, year)
    const statedate = new Date(year, month - 1, -6)
    const enddate = new Date(year, month - 1, lastDayOfThisMonth + 6)
    const startTime = `${moment(statedate).format('YYYY-MM-DD')} 00:00:00`
    const endTime = `${moment(enddate).format('YYYY-MM-DD')} 23:59:59`

    return {
      trashed,
      limit,
      username: ownerName,
      companyId: this.props.accountReducer.user.companyId,
      isIncludeChildBooking: false,
      startDatetime: startTime,
      endDatetime: endTime,
      status: JSON.stringify([0, 1, 2]),
      sorts: JSON.stringify([
        {
          type: 'ASC',
          column: 'startDatetime'
        }
      ]),
    }
  }

  onClickDate = (event, date) => {
    const { modalAction } = this.props

    modalAction.closeBookingMoreDetailModal()

    this.setState({
      position: getPositionBookingCard({ event, isMore: false, isYear: true }),
      date,
    }, () => this.getBookingListForYear(date))    
    
    modalAction.openBookingMoreDetailModal()
  }

  getBookingListForYear = (date) => {
    const { page, limit, username } = this.state
    const { bookingAction, accountReducer } = this.props
    const { language = 'EN' } = accountReducer

    const params = {
      startDatetime: moment(date).format('YYYY-MM-DD 00:00:00'),
      endDatetime: moment(date).format('YYYY-MM-DD 23:59:00'),
      username,
      companyId: accountReducer.user.companyId,
      isIncludeChildBooking: false,
      page,
      limit,
      status: JSON.stringify([0, 1, 2]),
      trashed: false
    }

    let nameModalText = '';
    let itemIdValue = '';

    bookingAction.getListAllBooking(params, () => {
      const { bookingReducer } = this.props

      const mapValue = bookingReducer.list.map((item) => {
        let startTime = item.startDatetime.split('T');
        startTime = startTime[1].split(':');
        startTime = startTime[0] + '.' + startTime[1];
        let endTime = item.endDatetime.split('T');
        endTime = endTime[1].split(':');
        endTime = endTime[0] + '.' + endTime[1];

        let start = startTime;
        let end = endTime;

        nameModalText = item.projectName;
        itemIdValue = item.id;

        const startDatetime = new Date(item.startDatetime.replace('Z', ''))

        const isRepeat = Boolean(item.recurrence)

        const recurrence = isRepeat ? item.recurrence : null

        return {
          id: item.id,
          title: item.projectName,
          day: getCalendarString(startDatetime, language),
          startTime: start,
          location: item.roomName,
          time: `${start} - ${end}`,
          detail: item.owner,
          status: item.status,
          description: item.description || CREATE_BOOKING.NO_DATA[this.props.accountReducer.language],
          owner: item.owner,
          recurrence,
          meetingLink: item.meetingLink,
          meetingLinkType: item.meetingLinkType,
          isEditable: item.isEditable
        }
      })

      this.setState({
        data: mapValue,
        isdetail: true,
        nameModal: nameModalText,
        itemId: itemIdValue
      });
    });

  }

  closeModal = () => {
    const { modalAction } = this.props
    modalAction.closeModalInformation()
    modalAction.closeBookingDetailModal()
    modalAction.closeBookingMoreDetailModal()
  }
  
  getTotalDayInMonth(month = (new Date()).getMonth(), year = (new Date()).getFullYear()) {
    return 32 - (new Date(year, month, 32)).getDate()
  }

  renderYear = () => {
    const { bookingcalendarReducer } = this.props
    let item = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
    const { allListEvent } = bookingcalendarReducer
    
    const tempdate = new Date(this.props.year, this.props.month - 1, this.props.date)

    let markDay = []
    let list = []
    for(let i in allListEvent){
      list.push([allListEvent[i]]);
    }

    list.forEach((month, index) => {
      month.forEach((listDay)=>{
       listDay.forEach((date)=>{
         markDay.push({
           month: index,
           date
         })
       })
     })
    })

    return item.map((e, index) => {
      let eMonth = new Date(this.props.year, e - 1).getMonth()
      let lastDayOfThisMonth = this.getTotalDayInMonth(new Date(this.props.year, eMonth).getMonth(), this.props.year)
      let dateNew = new Date(this.props.year, e - 1, this.props.date < lastDayOfThisMonth ? this.props.date : lastDayOfThisMonth)

      let dateMark = markDay.filter((item) => item.month === index).map((item) => item.date)

      return allListEvent && (
        <div className='calendar-year' key={index} >
          <SmallCalendar
            {...this.props}
            isShowing={true}
            selectDate={dateNew}
            startSelectable={dateNew}
            tempDate={tempdate}
            language={this.props.accountReducer.language}
            showArrow={false}
            onClickDate={this.onClickDate}
            dateMark={ dateMark }
            isSideBar={ false }
          />
        </div>
      )
    })
  }

  modal = {
    openModalConfirm: (bookingId) => {
      const {
        modalAction
      } = this.props
      this.setState({
        bookingId
      }, () => {
        modalAction.openModalConfirm()
      })
    },
    closeModalConfirm: () => {
      const {
        modalAction
      } = this.props
      modalAction.closeModalConfirm()
    },
    closeModalStatus: () => {
      const {
        modalAction
      } = this.props
      modalAction.closeModalStatus()
    }
  }

  openModalInformation = (event, dataInfo) => {
    event.stopPropagation()
    event.preventDefault()
    const {
      modalAction
    } = this.props
    this.setState({
      headerName: dataInfo.headerName,
      descriptionName: dataInfo.descriptionName,
      buttonName: dataInfo.buttonName,
    }, () => {
      modalAction.openModalInformation()
    })
  }

  openModalConfirm = () => {
    const {
      modalAction
    } = this.props
    modalAction.openModalConfirm()
  }

  setItemId = (itemId) => {
    this.setState({ itemId })
  }

  deleteBooking = () => {
    const { itemId } = this.state
    
    this.modal.openModalConfirm(itemId)
  }

  render() {
    const {
      date,
      data,
      nameModal,
      isYearAndDay,
      position,
      headerName,
      descriptionName,
      buttonName
    } = this.state

    const { 
      history, 
      accountReducer, 
      modalReducer, 
      settingReducer, 
      bookingcalendarReducer,
      bookingcalendarAction,
      modalAction,
    } = this.props
    const { isOpenBookingMoreDetailModal } = modalReducer

    return (
      <StyleYear>
        {isOpenBookingMoreDetailModal ?
          <ModalBookingList
            colorTheme={settingReducer.settingTheme.colorTheme}
            language={accountReducer.language}
            bookingcalendarReducer={bookingcalendarReducer}
            bookings={data}
            history={history}
            date={date}
            typeModal={BOOKING_DETAIL_VIEW.YEAR_VIEW}
            position={position}
            closeModal={this.closeModal}
            setItemId={this.setItemId}
            deleteBooking={this.deleteBooking}
            permission={ accountReducer.permission }
            isFloorPlan={false}
            modalReducer={modalReducer}
            modalAction={modalAction}
            bookingcalendarAction={bookingcalendarAction}
            nameModal={nameModal}
            objGetParams={this.objGetParams}
            isYearAndDay={isYearAndDay}
            onClickInformation={(event, dataInfo) => this.openModalInformation(event, dataInfo)}
            onClickConfirm={() => this.openModalConfirm()}
          /> : null
        }
        <div className='body'>
          {this.renderYear()}
        </div>

        {modalReducer.isOpenModalInformation && <ModalInformation
          headerName={headerName}
          colorTheme={settingReducer.settingTheme.colorTheme}
          descriptionName={descriptionName}
          buttonName={buttonName}
          onClick={this.closeModal}
        />}
      </StyleYear>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    accountAction: bindActionCreators(ACCOUNT.action, dispatch),
    bookingcalendarAction: bindActionCreators(BOOKINGCALENDAR.action, dispatch),
    bookingAction: bindActionCreators(BOOKING.action, dispatch),
    modalAction: bindActionCreators(MODAL.action, dispatch),
    holidayAction: bindActionCreators(HOLIDAY.action, dispatch),
  }
}

export const mapStateToProps = ({ settingReducer, accountReducer, loaderReducer, bookingReducer, bookingcalendarReducer, modalReducer, holidayReducer }) => {
  return {
    accountReducer,
    loaderReducer,
    bookingReducer,
    bookingcalendarReducer,
    modalReducer,
    holidayReducer,
    settingReducer
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Year)
